"use client";

import { Button } from "@workspace/ui/components/button";
import { Card, CardContent, CardFooter } from "@workspace/ui/components/card";
import { AlertCircle } from "lucide-react";

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

export default function ErrorFallback({
  error,
  resetErrorBoundary,
}: ErrorFallbackProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4">
      <Card className="w-full max-w-md border-zinc-700">
        <CardContent className="pt-6">
          <div className="flex flex-col items-center space-y-4 text-center">
            <AlertCircle className="h-6 w-6 text-zinc-700" />
            <div className="space-y-2">
              <h3 className="text-lg font-semibold">Something went wrong</h3>
              <p className="text-sm text-muted-foreground">{error.message}</p>
            </div>
          </div>
        </CardContent>
        <CardFooter>
          <Button onClick={resetErrorBoundary} className="w-full">
            Try again
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
